/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/1152g05j/screen/67851869
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import EditDropdown from '@components/EditDropdown';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import Rating from '@components/@core/Rating';
import CommunityActions from '~/actions/community';
import { inPage } from '~/services/util';

import QuillEditor from '@components/@core/QuillEditor';

const RatingCard = ({ ratings, callback }) => {
    const dispatch = useDispatch();

    const avatar = useSelector((state) => state.app.avatar);
    const userName = useSelector((state) => `${state.app.first_name} ${state.app.last_name}`);
    const loginUser = useSelector((state) => state.app.user?.community_user) || {};

    const [commentRate, setCommentRate] = useState(null);
    const [comment, setComment] = useState(null);
    const [page, setPage] = useState(1);
    const perPage = 10;
    const total = Math.ceil(ratings.length / perPage);

    const handleSetComment = () => {
        const payload = { comment: { parent_id: commentRate.id, data: { body: comment } } };
        dispatch(CommunityActions.addtopiccommentRequest(payload, callback));
        setComment(null);
        setCommentRate(null);
    };

    const handleFlagSpam = (content_id) => (e) => {
        const payload = { contentId: content_id, flag: 'spam' };
        dispatch(CommunityActions.postcontentflagRequest(payload));
    };

    return (
        <>
            {ratings.map((rate, index) => {
                if (inPage(index, page, perPage)) {
                    const { id, comments, data, created_at } = rate;
                    const now = moment();
                    const createdAt = moment(created_at);
                    const diff = Math.ceil(moment.duration(now.diff(createdAt)).asDays());
                    const rateDate = diff > 7 ? createdAt.format('YYYY/MM/DD') : `${diff} days ago`;
                    return (
                        <div key={id} className="d-flex mt-4">
                            <div className="manager">
                                <Icon name="fas fa-shield-halved" color="#969faa" size={14} />
                            </div>
                            <div className="d-flex-1">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <p className="dsl-b14 mb-2">{data?.job_description}</p>
                                        <p className="dsl-m14 mb-0">{diff === 0 ? 'Today' : rateDate}</p>
                                    </div>
                                    <div>
                                        <Rating className="mb-2" score={data?.stars} />
                                        <div className="dsl-b14 mb-2">{`Recommended: ${data?.recommended !== '0' ? 'YES' : 'NO'}`}</div>
                                        {data?.status === 'verified' && (
                                            <div className="d-h-between">
                                                <Icon name="fas fa-circle-check" color="#969faa" size={14} />
                                                <span className="dsl-p14 text-400 ms-2">VERIFIED RATING</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between ">
                                    <div>
                                        <p className="dsl-b14 text-400 mb-0">Pros:</p>
                                        <p className="dsl-m14 fst-italic mb-2">{data?.pros}</p>
                                        <p className="dsl-b14 text-400 mb-0">Cons:</p>
                                        <p className="dsl-m14 fst-italic mb-3">{data?.cons}</p>
                                    </div>
                                    <div className="d-h-center">{loginUser.id && loginUser.id !== id && <EditDropdown options={['Flag Spam']} onChange={handleFlagSpam(id)} />}</div>
                                </div>

                                <Button className="p-0 d-h-start" type="link" onClick={() => setCommentRate(rate)}>
                                    <Icon name="fas fa-comment" color="#969faa" size={14} />
                                    <span className="dsl-m14 ms-2">{comments.length}</span>
                                </Button>
                                {commentRate?.id && commentRate.id === id && (
                                    <div className="border-top pt-4">
                                        <p className="dsl-b18 text-400">Comments:</p>
                                        <div className="input-comment">
                                            <div className="avatar-section">
                                                <Avatar type="logo" name={userName} url={`${avatar}?${Date.now()}`} />
                                            </div>
                                            <div className="w-100">
                                                <QuillEditor
                                                    className="w-80"
                                                    placeholder="Type a comment"
                                                    theme="snow"
                                                    value={comment}
                                                    modules={{ toolbar: { container: [['link']] } }}
                                                    onChange={(e) => setComment(e)}
                                                />
                                            </div>
                                            <Button className="ml-2" type="medium" name="COMMENT" disabled={!comment} onClick={handleSetComment} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                }
                return null;
            })}
            <Pagination current={page} per={10} pers={[]} total={total} onChange={(e) => setPage(e)} />
        </>
    );
};

RatingCard.propTypes = {
    ratings: PropTypes.array,
    callback: PropTypes.func,
};

RatingCard.defaultProps = {
    ratings: [],
    callback: () => {},
};

export default RatingCard;
